namespace TabAurous.Finance {
    export interface ServiceInwardDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        LedgerId?: number;
        LedgerName?: string;
        ServiceId?: number;
        ServiceCode?: string;
        TaxCode?: string;
        CategoryId?: number;
        Amount?: number;
    }

    export namespace ServiceInwardDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Finance.ServiceInwardDetails';
        export const deletePermission = 'Finance:ServiceInward:Delete';
        export const insertPermission = 'Finance:ServiceInward:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:ServiceInward:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            ServiceId = "ServiceId",
            ServiceCode = "ServiceCode",
            TaxCode = "TaxCode",
            CategoryId = "CategoryId",
            Amount = "Amount"
        }
    }
}
